import React from 'react';

export default function ShippingPolicy() {
  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Shipping Policy</h1>
      <p>We ship through trusted partners such as Professional Courier and Porter.</p>
      <p>Shipping charges may vary depending on the delivery location and weight of the products.</p>
      <p>We aim to dispatch products within 24–48 hours of order confirmation, excluding weekends and holidays.</p>
    </div>
  );
}
